import React, { useState, useRef } from 'react';
import { DropzoneArea as DZA } from '@shotskydiver/material-ui-dropzone';
import { MAXSIZE } from '../drop-area';
import SnackAlerts from 'global/components/snack-alerts';
import { get, set, size } from 'global/lib/lodash';

export const DropzoneArea = React.forwardRef((props, ref) => {
  const [alerts, setAlerts] = useState();
  const dropRef = useRef(ref);

  const onChange = async (files) => {
    try {
      const errors = [];
      const acceptedFiles = [];
      const rejected = [];
      await Promise.all(
        files.map(async (file, index) => {
          acceptedFiles.push(file);
        })
      );

      const del = get(dropRef, 'current.deleteFile', () => 0);
      rejected.map((rej) => {
        del(rej.file, rej.index);
      });
      props.onChange && props.onChange(acceptedFiles);
      if (size(errors)) {
        const hasAlert = props.onAlert;
        const message = errors.map((e) => e.message).join(', ');
        if (hasAlert) {
          props.onAlert && props.onAlert(message, 'overwrite');
        } else {
          setAlerts({
            message,
            severity: 'error',
          });
        }
      }
    } catch (err) {
      setAlerts({ message: err.message, severity: 'error' });
    }
  };

  set(ref, 'current', dropRef.current);

  return (
    <>
      <DZA ref={dropRef} maxFileSize={MAXSIZE} {...props} onChange={onChange} />
      <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
    </>
  );
});
